export default "__VITE_ASSET__BUS3aM2Q__"